module.exports = __webpack_public_path__ + "static/media/sunwheel.56d77a1f.png";